import Component from './ProfileHero';
import Container from './ProfileHero.container';

export default Container(Component);
